const UINT32_SCALE = 1 / 4_294_967_296

function hashLabel(seed: number, label: string | number): number {
  const text = String(label)
  let hash = (2_166_136_261 ^ seed) >>> 0
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index)
    hash = Math.imul(hash, 16_777_619) >>> 0
  }
  return hash || 0x6d2b79f5
}

/** A compact deterministic PRNG with stable, order-independent fork streams. */
export class SeededRandom {
  private state: number
  private readonly rootSeed: number

  public constructor(seed: number) {
    this.rootSeed = seed >>> 0 || 0x6d2b79f5
    this.state = this.rootSeed
  }

  public nextUint32(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0
    let value = this.state
    value = Math.imul(value ^ (value >>> 15), value | 1)
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61)
    return (value ^ (value >>> 14)) >>> 0
  }

  public nextFloat(): number {
    return this.nextUint32() * UINT32_SCALE
  }

  public range(minimum: number, maximum: number): number {
    return minimum + (maximum - minimum) * this.nextFloat()
  }

  public integer(minimum: number, maximumExclusive: number): number {
    return minimum + Math.floor(this.nextFloat() * (maximumExclusive - minimum))
  }

  public fork(label: string | number): SeededRandom {
    return new SeededRandom(hashLabel(this.rootSeed, label))
  }
}
